"use client";

import {
  Button,
  makeStyles,
  MessageBar,
  Text,
} from "@fluentui/react-components";
import { getErrorMessage, type FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { SkanskaColorTokens } from "../../style/colors";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: "16px",
  },
  header: {
    color: SkanskaColorTokens.color_action_red,
    textWrap: "balance",
  },
  button: {
    maxWidth: "200px",
    marginLeft: "auto",
  },
});

function ErrorFallbackComponent({ error, resetErrorBoundary }: FallbackProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const errorMessage = getErrorMessage(error) ?? t("someError");

  return (
    <MessageBar intent={"error"}>
      <div className={classes.root}>
        <h1 className={classes.header}> {t("someError")}</h1>
        <Text>{errorMessage}</Text>
        <Button
          className={classes.button}
          appearance="primary"
          onClick={resetErrorBoundary}
        >
          {t("tryAgain")}
        </Button>
      </div>
    </MessageBar>
  );
}

export default ErrorFallbackComponent;
